var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadInvoice = function SvgDownloadInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "1684 792 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11060",
    fill: "#26890d",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1703.173 798.641a.486.486 0 0 0-.348-.153h-7.805c-1.44 0-2.629 1.173-2.629 2.6v14.616c0 1.426 1.19 2.599 2.63 2.599h10.593c1.44 0 2.629-1.173 2.629-2.6v-11.605a.513.513 0 0 0-.14-.335l-4.93-5.122Zm.14 1.537 3.301 3.431h-2.146a1.145 1.145 0 0 1-1.155-1.139v-2.292Zm2.3 17.168h-10.593c-.903 0-1.662-.742-1.662-1.642v-14.617c0-.895.754-1.641 1.662-1.641h7.327v3.024c0 1.163.947 2.097 2.121 2.097h2.808v11.137c0 .9-.754 1.642-1.662 1.642Zm0 0",
    "data-name": "Path 133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.314 814.04h-7.994a.484.484 0 0 0-.486.48c0 .265.219.48.486.48h8a.484.484 0 0 0 .485-.48.485.485 0 0 0-.49-.48Zm0 0",
    "data-name": "Path 134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1699.967 812.336a.484.484 0 0 0 .35.153c.135 0 .26-.057.35-.153l2.814-3.02a.478.478 0 1 0-.7-.654l-1.984 2.128v-5.244a.482.482 0 0 0-.48-.48.482.482 0 0 0-.48.48v5.244l-1.978-2.128a.479.479 0 1 0-.701.654l2.809 3.02Zm0 0",
    "data-name": "Path 135"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1700 792c-8.876 0-16 7.18-16 16 0 8.876 7.18 16 16 16s16-7.18 16-16-7.18-16-16-16m0 30.926c-8.198 0-14.87-6.672-14.87-14.87 0-8.197 6.672-14.869 14.87-14.869s14.87 6.672 14.87 14.87c0 8.197-6.672 14.869-14.87 14.869",
    "data-name": "Path 280411"
  }))));
};
export default SvgDownloadInvoice;